export function betterParseInt(v: unknown): number | undefined {
  if (v === null || v === undefined) return undefined;
  if (typeof v === 'number') return v;
  return parseInt(String(v).replaceAll(/[^0-9\\.]/g, ''), 10);
}
